module.exports = __webpack_public_path__ + "img/main-background.ae304fa8.png";